export enum StandardFilterType {
    LQA = 'LQA',
    custom1 = 'custom1',
    custom2 = 'custom2',
    custom3 = 'custom3',
}
